export function getCourseLesson(name) {
  if (process.env.NODE_ENV === 'development') {
    return import('../mock/courseLessonData').then((module) => {
      return module.mockData().data;
    });
  }

  const wpnonce = window?.dataWP?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `&_wpnonce=${wpnonce}` : '';

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_lesson?origin_app=wp-react&post_name=${name}${wpNonceParam}`,
    {
      method: 'GET',
    }
  )
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      if (!res.success) {
        throw Error(res.data.message);
      }

      return res.data;
    });
}
